export default __webpack_public_path__ + "static/media/vault.a46106f6.png";